"use client"

import { motion } from "framer-motion"
import { useEffect, useState } from "react"

import { technos as technosList } from "@/data/technos"

import { useSearch } from "@/hooks/use-search"

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer"

import Search from "../ui/icons/search"
import { Input } from "../ui/input"
import NavChoice from "./nav-choice"

export default function TechnologiesFilter() {
  const { filter, search } = useSearch()
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 1024;
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2, delay: 0.1 }}
        className="hidden h-full flex-col gap-[28px] lg:flex"
      >
        <TechnologiesFilterContent />
      </motion.div>
      {isMobile && (
        <Drawer
          onClose={() => {
            search({
              filter: null,
            })
          }}
          dismissible
          open={filter === "Technologies"}
        >
          <DrawerContent>
            <DrawerHeader>
              <DrawerTitle>Technologies selection</DrawerTitle>
              <DrawerDescription>
                Select the technologies you need
              </DrawerDescription>
            </DrawerHeader>
            <div className="mx-auto w-full max-w-[800px] shrink-0 p-4">
              <TechnologiesFilterContent />
            </div>
          </DrawerContent>
        </Drawer>
      )}
    </>
  )
}

export function TechnologiesFilterContent() {
  const [searchTech, setSearchTech] = useState<string>("")
  const [selectedTechnos, setSelectedTechnos] = useState<string[]>([])
  const { technos, search } = useSearch()
  useEffect(() => {
    if (selectedTechnos.length) return

    if (technos) {
      const currentTechnos = technos.split(",")
      setSelectedTechnos(currentTechnos)
    }
  }, [technos])

  return (
    <>
      <Input
        Icon={Search}
        value={searchTech}
        onChange={(e) => {
          setSearchTech(e.target.value)
        }}
        placeholder="Your stack..."
      />
      <div>
        <div className="flex max-h-[500px] w-full flex-col !gap-[10px] overflow-y-auto pb-10 lg:h-full lg:max-h-full">
          {technosList
            .filter((el) => {
              if (!search) return true
              return el.name.toLowerCase().includes(searchTech.toLowerCase())
            })
            .sort((tech1, tech2) => {
              if (selectedTechnos.includes(tech1.name)) {
                if (selectedTechnos.includes(tech2.name))
                  return tech1.name.localeCompare(tech2.name)
                return -1
              }
              if (selectedTechnos.includes(tech2.name)) {
                return 1
              }
              return tech1.name.localeCompare(tech2.name)
            })
            .map(({ icon: Icon, name }, i) => {
              return (
                <NavChoice
                  selectedItems={selectedTechnos}
                  name={name}
                  Icon={Icon}
                  className="w-full"
                  key={`techno-${i}-${name}`}
                  onClick={() => {
                    const newTechnos = selectedTechnos.includes(name)
                      ? selectedTechnos.filter((t: any) => t !== name)
                      : [...selectedTechnos, name]
                    setSelectedTechnos(newTechnos)
                    search({
                      technos: newTechnos,
                    })
                  }}
                />
              )
            })}
        </div>
      </div>
    </>
  )
}
